import { BrowserAuthErrorCodes } from '@azure/msal-browser';
import { loginRequest } from 'src/compass/site/config';

// Resolves the access token, or undefined when it can't be had silently - and then sends the
// browser to sign-in, whatever the error. Not only InteractionRequiredAuthError: once the 24-hour
// refresh token has expired MSAL renews through a hidden iframe, and when that times out
// (BrowserAuthError monitor_window_timeout) the app used to load with no permissions and an empty
// menu (15708). A top-level redirect completes the same SSO and comes back to this page.
export function acquireAuthToken(instance: any, account: any) {
  return new Promise((resolve) => {
    instance
      .acquireTokenSilent({
        ...loginRequest,
        account,
      })
      .then((result: { accessToken: any }) => resolve(result.accessToken))
      .catch((error: any) => {
        console.error('Silent token request failed - redirecting to sign-in.', error);
        instance
          .acquireTokenRedirect({
            ...loginRequest,
            // The API interceptor passes no account; the silent request fell back to the active one.
            account: account ?? instance.getActiveAccount() ?? undefined,
          })
          .catch((redirectError: any) => {
            // AuthContextProvider and an API request often fail together; the first redirect wins.
            if (redirectError?.errorCode !== BrowserAuthErrorCodes.interactionInProgress)
              console.error('Sign-in redirect failed.', redirectError);
          });
        resolve(undefined);
      });
  });
}
